(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-form"] && !Shopify.designMode) return;
  try {
    /* Magnetic CTA. Interaction idea referenced from React Bits "Magnet" (no code used).
     Fine pointers + motion allowed only; uses the `translate` property so layout never moves. */
  if (!customElements.get('ls-magnet')) {
    customElements.define(
      'ls-magnet',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button, a');
          const allowed =
            this.button &&
            window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
            document.documentElement.classList.contains('motion-ok');
          if (!allowed) return;
          this.zone = this.closest('[data-magnet-zone]') || this.parentElement;
          this.frame = null;
          this.onMove = (event) => {
            if (this.button.disabled) return;
            const rect = this.getBoundingClientRect();
            const dx = event.clientX - (rect.left + rect.width / 2);
            const dy = event.clientY - (rect.top + rect.height / 2);
            const reach = Math.max(rect.width, rect.height) / 2 + 48;
            const inside = Math.hypot(dx, dy) < reach;
            this.queue(inside ? (dx / reach) * 6 : 0, inside ? (dy / reach) * 6 : 0);
          };
          this.onLeave = () => this.queue(0, 0);
          this.zone.addEventListener('pointermove', this.onMove);
          this.zone.addEventListener('pointerleave', this.onLeave);
        }

        disconnectedCallback() {
          if (!this.zone) return;
          this.zone.removeEventListener('pointermove', this.onMove);
          this.zone.removeEventListener('pointerleave', this.onLeave);
        }

        queue(x, y) {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            this.button.style.translate = x || y ? `${x.toFixed(1)}px ${y.toFixed(1)}px` : '';
          });
        }
      }
    );
  }

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const price = option ? option.dataset.price : null;
    if (!price) return;
    const scope = select.closest('section') || select.closest('form');
    scope.querySelectorAll('[data-price], [data-button-price]').forEach((el) => {
      el.textContent = price;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["launch-signals"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ls-price-rise')) {
    customElements.define(
      'ls-price-rise',
      class extends HTMLElement {
        connectedCallback() {
          this.deadline = Number(this.dataset.deadline);
          if (!this.deadline) return;
          this.formatDeadline();
          this.countdown = this.querySelector('[data-countdown]');
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        formatDeadline() {
          const text = this.querySelector('[data-deadline-text]');
          if (!text) return;
          try {
            const formatted = new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
              day: 'numeric',
              month: 'long',
              hour: 'numeric',
              minute: '2-digit',
              timeZone: this.dataset.timezone,
            }).format(new Date(this.deadline));
            text.textContent = this.dataset.zoneLabel ? formatted + ' ' + this.dataset.zoneLabel : formatted;
          } catch (error) {
            /* Keep the server-rendered date when the timezone is invalid. */
          }
        }

        tick() {
          const left = this.deadline - Date.now();
          if (left <= 0) {
            clearInterval(this.timer);
            if (this.dataset.expired === 'ended') this.textContent = this.dataset.ended;
            else this.hidden = true;
            return;
          }
          if (!this.countdown) return;
          const s = Math.floor(left / 1000);
          const d = Math.floor(s / 86400);
          const h = Math.floor((s % 86400) / 3600);
          const m = Math.floor((s % 3600) / 60);
          const sec = s % 60;
          const pad = (n) => String(n).padStart(2, '0');
          this.countdown.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
          this.countdown.hidden = false;
        }
      }
    );
  }

  if (!customElements.get('ls-crowd-signal')) {
    customElements.define(
      'ls-crowd-signal',
      class extends HTMLElement {
        connectedCallback() {
          const endpoint = this.dataset.endpoint;
          if (!endpoint || !/^https:\/\//.test(endpoint)) return;
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 4000);
          fetch(endpoint, { signal: controller.signal, credentials: 'omit', headers: { Accept: 'application/json' } })
            .then((response) => (response.ok ? response.json() : null))
            .then((data) => this.render(data))
            .catch(() => {})
            .finally(() => clearTimeout(timeout));
        }

        render(data) {
          if (!data || typeof data !== 'object') return;
          const generated = Date.parse(data.generated_at);
          const maxAge = Number(this.dataset.maxAge) || 300;
          if (!generated || Date.now() - generated > maxAge * 1000 || generated - Date.now() > 60000) return;
          const valid = (n) => Number.isInteger(n) && n > 0 && n < 1000000;
          const lines = [];
          if (valid(data.active_visitors)) {
            const key = data.active_visitors === 1 ? 'viewersOne' : 'viewersOther';
            lines.push(this.dataset[key].replace('__COUNT__', data.active_visitors));
          }
          if (valid(data.purchases_24h)) {
            const key = data.purchases_24h === 1 ? 'purchasesOne' : 'purchasesOther';
            lines.push(this.dataset[key].replace('__COUNT__', data.purchases_24h));
          }
          if (!lines.length) return;
          this.textContent = lines.join(' · ');
          this.hidden = false;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["motion-runtime"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.documentElement;
    var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    function motionAllowed() {
      return root.classList.contains('motion-ok') && !reduceQuery.matches;
    }

    function fineHover() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    var revealObserver =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-in');
                revealObserver.unobserve(entry.target);
              });
            },
            { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
          )
        : null;

    var ambientObserver =
      'IntersectionObserver' in window
        ? new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              entry.target.classList.toggle('is-paused', !entry.isIntersecting);
              entry.target.dispatchEvent(
                new CustomEvent('ls:visibility', { detail: { visible: entry.isIntersecting } })
              );
            });
          })
        : null;

    function splitWords(el) {
      if (el.dataset.split) return;
      el.dataset.split = 'true';
      var index = 0;
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        var parts = node.textContent.split(/(\s+)/);
        if (parts.length < 2 && !parts[0].trim()) return;
        var fragment = document.createDocumentFragment();
        parts.forEach(function (part) {
          if (!part) return;
          if (!part.trim()) {
            fragment.appendChild(document.createTextNode(part));
            return;
          }
          var word = document.createElement('span');
          word.className = 'ls-word';
          word.style.setProperty('--w', index++);
          word.textContent = part;
          fragment.appendChild(word);
        });
        node.parentNode.replaceChild(fragment, node);
      });
    }

    function init(scope) {
      scope = scope || document;
      if (motionAllowed()) scope.querySelectorAll('[data-words]').forEach(splitWords);
      scope.querySelectorAll('[data-reveal-group]').forEach(function (group) {
        group.querySelectorAll(':scope > [data-reveal]').forEach(function (child, index) {
          child.style.setProperty('--i', index);
        });
      });
      scope.querySelectorAll('[data-reveal]:not(.is-in)').forEach(function (el) {
        if (revealObserver && motionAllowed()) {
          revealObserver.observe(el);
        } else {
          el.classList.add('is-in');
        }
      });
      if (ambientObserver) {
        scope.querySelectorAll('[data-ambient]').forEach(function (el) {
          ambientObserver.observe(el);
        });
      }
    }

    function fetchSections(url, options) {
      return fetch(url, options).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            var error = new Error(data.description || data.message || response.statusText);
            error.data = data;
            throw error;
          }
          return data;
        });
      });
    }

    window.LaunchStudio = {
      motionAllowed: motionAllowed,
      fineHover: fineHover,
      init: init,
      fetchSections: fetchSections,
      routes: (window.Shopify && window.Shopify.routes) || { root: '/' }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    reduceQuery.addEventListener('change', function () {
      if (reduceQuery.matches) root.classList.remove('motion-ok');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-facade"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ls-video')) {
    customElements.define(
      'ls-video',
      class extends HTMLElement {
        connectedCallback() {
          const trigger = this.querySelector('[data-video-trigger]');
          if (!trigger) return;
          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            const iframe = document.createElement('iframe');
            iframe.src = this.dataset.src;
            iframe.title = this.dataset.title || '';
            iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
            iframe.allowFullscreen = true;
            trigger.replaceWith(iframe);
            iframe.focus();
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
